import {
  ADDHEALTHDETAILS,
  ADDHEALTHNUMBER,
  ALLHEALTHDETAILS,
  HEALTHNUMFLAG,
  SUMINSURANCE_AMOUNT,
  HEALTH_QQ_POST,
  HEALTH_QUOTE,
  ERROR_QUOTES_HEALTH,
  HEALTH_QUESTION,
  CREATE_PROPOSAL_HEALTH,
  CUST_DETAIL_HEALTH,
  KYC_STATUS_HEALTH,
  POLICY_PDF_Health,
} from "../actiontypes/NumHealthActiontypes";
import axiosInstance from "../axios/AxiosInstance";
import axiosInHealth from "../axios/AxiosInHealth";
export const numhealthflagfalse = () => {
  return {
    type: HEALTHNUMFLAG,
  };
};
export const CustHealth_detail = (data) => {
  return {
    type: CUST_DETAIL_HEALTH,
    payload: data,
  };
};
export const allhealthdetails = (data) => {
  return {
    type: ALLHEALTHDETAILS,
    payload: data,
  };
};
export const addhealthnum = (data) => {
  console.log(data);
  return {
    type: ADDHEALTHNUMBER,
    payload: data,
  };
};
export const addhealthdetails = (data) => {
  return {
    type: ADDHEALTHDETAILS,
    payload: data,
  };
};
export function suminsurance_action(data) {
  return {
    type: SUMINSURANCE_AMOUNT,
    payload: data,
  };
}
export const PostQuoteHealth = (data) => {
  return {
    type: HEALTH_QQ_POST,
    payload: data,
  };
};
export const QuickQuoteHealth = (data) => {
  return {
    type: HEALTH_QUOTE,
    payload: data,
  };
};
export function ErrQuotesHealth(data) {
  return {
    type: ERROR_QUOTES_HEALTH,
    payload: data,
  };
}
export const HealthQuestions = (data) => {
  return {
    type: HEALTH_QUESTION,
    payload: data,
  };
};
export const CreateProposal = (data) => {
  return {
    type: CREATE_PROPOSAL_HEALTH,
    payload: data,
  };
};
export const KycHealth = (data) => {
  return {
    type: KYC_STATUS_HEALTH,
    payload: data,
  };
};
export const PdfHealth = (data) => {
  return {
    type: POLICY_PDF_Health,
    payload: data,
  };
};
export const sumInsuredamount = () => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      axiosInHealth
        .get("v1/health_insurance/SumInsured")
        .then(function (response) {
          // console.log(response);
          dispatch(suminsurance_action(response.data.data));
          resolve(response.data.data);
        })
        .catch(function (error) {
          console.log(error);
          reject(error);
        });
    });
  };
};

export const chooseplan = () => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get("v1/health_insurance/SubInsuranceHealth")
        .then(function (response) {
          // console.log(response);
          // dispatch(suminsurance_action(response.data.data));
          resolve(response.data.data);
        })
        .catch(function (error) {
          console.log(error);
          reject(error);
        });
    });
  };
};
